import React from 'react';
import TpEvaluatorService from '../../../Services/TpEvaluatorService';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpEvaluatorTextMessageItem from '../../../Domain/TpEvaluatorTextMessageItem';
import TpEvaluatorTextMessageSearchParams from './TpEvaluatorTextMessageSearchParams';

class TpEvaluatorTextMessageAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new TpEvaluatorTextMessageSearchParams(),
      cleared: process.env.NODE_ENV !== 'development',
    };
    this.startSearch = this.startSearch.bind(this);
    this.startExport = this.startExport.bind(this);
    this.handleExportOnClick = this.handleExportOnClick.bind(this);
  }

  startSearch(searchItem) {
    this.setState({
      searchItem,
      cleared: false,
    });
  }

  startExport() {
    TpEvaluatorService.ExportToExcelForView(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('TPETMA33')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  handleExportOnClick() {
    if (
      this.state.searchItem.IncludeSelfDeactivated === 'true' ||
      this.state.searchItem.IncludeNATextMessageAuthorized === 'true'
    ) {
      const notificationMessage =
        this.state.searchItem.IncludeSelfDeactivated === 'true' &&
        this.state.searchItem.IncludeNATextMessageAuthorized === 'true'
          ? 'The search included self-deactivated shoppers and shoppers who have not set the text authorization.'
          : this.state.searchItem.IncludeSelfDeactivated === 'true'
          ? 'The search included self-deactivated shoppers.'
          : 'The search included shoppers who have not set the text authorization.';

      ErrorMessage.SetApprove(
        <span>
          {notificationMessage}
          <br />
          Are you sure you want to proceed with the export?
        </span>,
        () => this.startExport()
      );
    } else {
      this.startExport();
    }
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={TpEvaluatorTextMessageItem}
          serviceFunction={TpEvaluatorService.GetAllItemBySearchingForTextMessage}
          convertDBItemsFunction={TpEvaluatorService.ConvertDBItemsForTextMessage}
          searchParamsType={TpEvaluatorTextMessageSearchParams}
          orderDirection={OrderDirectionsEnum.Asc}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          cleared={this.state.cleared}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different id, name or email...'
          errorCode='TPETMA81'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportOnClick}
        />
      </div>
    );
  }
}

export default TpEvaluatorTextMessageAdmin;
